import { render } from "./SvgMap.vue?vue&type=template&id=1df3c6a4"
import script from "./SvgMap.vue?vue&type=script&lang=js"
export * from "./SvgMap.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__